import { FC } from "react";
import { generateDateLabelByBudgetPeriod } from "../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/budgets/tooltip/utils/helpers/generateDateLabelByBudgetPeriod";
import { Budget } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const BudgetsCustomPeriodCell: FC<{ budget: Budget }> = ({ budget }) => {
  const startDate = budget.start_date;
  const endDate = budget.end_date;
  const period = budget.period;

  const formattedDate = generateDateLabelByBudgetPeriod({
    startDate,
    endDate: endDate ?? undefined,
    period,
  });

  return <TypographyWithTooltip title={formattedDate} variant="body2" />;
};
